import { useLocation, Link } from "react-router-dom";

// Persistent bottom nav (like the one that shows when someone opens the site
// from an Instagram/social link). Hidden inside the logged-in app + admin.
const HIDE_PREFIXES = ["/app", "/admin", "/content-engine", "/login", "/register"];

export const StickyBottomBar = () => {
  const { pathname } = useLocation();
  if (HIDE_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  const links = [
    { label: "Home", to: "/" },
    { label: "Results", to: "/live-scores" },
    { label: "Today's Tips", to: "/free-preview" },
  ];

  return (
    <div
      data-testid="sticky-bottom-bar"
      className="fixed bottom-0 left-0 right-0 z-50 bg-[#0b0f14]/95 backdrop-blur border-t border-white/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="max-w-5xl mx-auto flex items-center gap-2 px-3 py-2.5">
        <Link to="/" className="shrink-0" data-testid="sticky-logo">
          <div className="w-9 h-9 rounded-lg bg-emerald-500 flex items-center justify-center font-black text-[#0b0f14] text-lg">S</div>
        </Link>
        <nav className="flex items-center gap-4 flex-1 overflow-x-auto no-scrollbar">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`sticky-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className={`text-sm font-semibold whitespace-nowrap transition-colors ${
                pathname === l.to ? "text-white" : "text-zinc-400 hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <Link
          to="/free-trial"
          data-testid="sticky-join-vip"
          className="shrink-0 bg-emerald-500 hover:bg-emerald-400 text-[#0b0f14] font-bold text-sm px-5 py-2.5 rounded-full transition-colors"
        >
          Join VIP
        </Link>
      </div>
    </div>
  );
};
